import InitialState from './initialState';
import ActionTypes from '../actions/actionTypes';
import { MessageTypes } from '../constants';

const messageTypeMapping = {
  [ActionTypes.MESSAGE_ERROR]: MessageTypes.ERROR,
  [ActionTypes.MESSAGE_WARNING]: MessageTypes.WARNING,
  [ActionTypes.MESSAGE_INFO]: MessageTypes.INFO,
  [ActionTypes.MESSAGE_SUCCESS]: MessageTypes.SUCCESS,
  [ActionTypes.MESSAGE_API_ERRORS]: MessageTypes.API_ERRORS,
};

export default function(state = InitialState.message, action) {
  if (messageTypeMapping[action.type]) {
    return {
      type: messageTypeMapping[action.type],
      content: action.payload,
    };
  }
  return state;
}
